import { OrderType } from '@epi-constants/orderType';
import createReducer from '../../helpers/CreateReducer';
import { getConstantValue } from '../../helpers/ConstantHelper';
import { ApiConstants } from '../../constants/actions';
import { PaymentMethods } from '../../constants/paymentMethods';
import { PaymentStatuses } from '../../constants/paymentStatuses';

interface PaymentStatusState {
  status: string | null;
  paymentMethod: string | null;
  forwardEmail: string;
  orderType: string;
  isLoading: boolean;
  isError: boolean;
  isUnauthorized: boolean;
  noPersistance: boolean;
}

interface PaymentStatusPayload {
  status: string;
  paymentMethod: string;
  forwardEmail: string;
  orderType: string;
}

interface FailureAction {
  isUnauthorized?: boolean;
}

export const getInitialState = (): PaymentStatusState => ({
  status: '',
  paymentMethod: '',
  forwardEmail: '',
  orderType: '',
  isLoading: true,
  isError: false,
  isUnauthorized: false,
  noPersistance: true
});

export default createReducer(getInitialState, {
  [`${ApiConstants.GET_PAYMENT_STATUS}_REQUEST`]:
    (): Partial<PaymentStatusState> => ({
      isLoading: true,
      isError: false,
      isUnauthorized: false
    }),
  [`${ApiConstants.GET_PAYMENT_STATUS}_SUCCESS`]: (
    state: PaymentStatusState,
    { payload }: { payload: PaymentStatusPayload }
  ): Partial<PaymentStatusState> => ({
    status: getConstantValue(PaymentStatuses, payload.status),
    paymentMethod: getConstantValue(PaymentMethods, payload.paymentMethod),
    forwardEmail: payload.forwardEmail,
    orderType:
      payload.orderType.toLowerCase() === OrderType.voucher
        ? OrderType.voucher
        : OrderType.digital,
    isError: false,
    isUnauthorized: false,
    isLoading: false
  }),
  [`${ApiConstants.GET_PAYMENT_STATUS}_FAILURE`]: (
    state: PaymentStatusState,
    { isUnauthorized }: FailureAction
  ): Partial<PaymentStatusState> => ({
    isError: true,
    isUnauthorized: isUnauthorized || false,
    isLoading: false
  })
});
